export var DEFAULT_SECTION_CLASSNAME = 'section';